import { PagingParameters } from "@/api/dtos";
import { getDashboardListKey } from "@/lib/dashboardListScrollRestore";
import { useDashboardListNavigate } from "@/hooks/useDashboardListNavigate";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

type Identifiable = { id: string };

export function useDashboardListScrollContext(
  data: Identifiable[] | undefined,
  pagination: PagingParameters,
  isFetching: boolean,
  viewStorageKey: string,
) {
  const location = useLocation();
  const listKey = getDashboardListKey(location.pathname, location.search);
  const { navigateToFiche } = useDashboardListNavigate({
    listKey,
    pagination,
    viewStorageKey,
  });
  const entityIds = useMemo(() => (data ?? []).map((item) => item.id), [data]);

  return {
    listKey,
    navigateToFiche,
    entityIds,
    isLoading: isFetching,
    listPagination: pagination,
  };
}
